<template>

    <div class="container">

        <!--
        <router-link to="/software/7" class="nav-link">
            <div class="card card-block d-flex new-post">
                <div class="card-body align-items-center d-flex justify-content-center">
                    NEW - OndEstudo
                </div>
            </div>
        </router-link>
        -->
        <router-link to="/softwares" class="nav-link">
            <div class="card text-white" style="border: none">
                <img class="card-img" src="https://i.ibb.co/71TxZ12/Software-Banner3.png">
                <div class="card-img-overlay d-flex justify-content-end">
                    <div class="card-title my-auto custom-font" style="margin-right:20%;">
                        Software
                    </div>
                </div>
            </div>
        </router-link>
        <router-link to="/designs" class="nav-link">
            <div class="card text-white" style="border: none">
                <img class="card-img" src="https://i.ibb.co/T1bLdDj/Design-Banner2.png">
                <div class="card-img-overlay d-flex justify-content-start">
                    <div class="card-title my-auto custom-font" style="margin-left:20%;">
                        Design
                    </div>
                </div>
            </div>
        </router-link>
        <!--
        <router-link to="/setups" class="nav-link">
            <div class="card text-white" style="border: none">
                <img class="card-img" src="https://i.ibb.co/8Y44BDS/soon-Banner.png">
                <div class="card-img-overlay d-flex justify-content-end">
                    <div class="card-title my-auto custom-font" style="margin-right:20%;">
                        Setup
                    </div>
                </div>
            </div>
        </router-link>
        <router-link to="/stores" class="nav-link">
            <div class="card text-white" style="border: none">
                <img class="card-img" src="https://i.ibb.co/8Y44BDS/soon-Banner.png">
                <div class="card-img-overlay d-flex justify-content-start">
                    <div class="card-title my-auto custom-font" style="margin-left:20%;">
                        Merch
                    </div>
                </div>
            </div>
        </router-link>
        -->
        <div class="card text-white" style="border: none">
            <img class="card-img" src="https://i.ibb.co/8Y44BDS/soon-Banner.png">
            <div class="card-img-overlay d-flex justify-content-start">
                <div class="card-title m-auto custom-font">
                    More coming soon...
                </div>
            </div>
        </div>
    </div>

</template>

<script>
</script>

<style>
.custom-font{
    font-family: 'ostrich';
    font-size:4vw;
}

.new-post{
    background-color: rgb(0, 140, 255);
}

@font-face {
    font-family: 'ostrich';
    src: url('../fonts/ostrich-regular.eot?#iefix') format('embedded-opentype'), 
    url('../fonts/ostrich-regular.woff') format('woff'), 
    url('../fonts/ostrich-regular.ttf') format('truetype'),
    url('../fonts/ostrich-regular.svg#svgFontName') format('svg');
}
</style>